import { createSelector } from 'reselect';
import { arrayize } from 'utils/converters';
import { usersIncreasingAlphabetical } from 'utils/sort';

const mapStaff = ({
  name,
  first_name,
  last_name,
  email,
  groups,
  routes,
  id,
  is_active,
  has_logged,
  available,
}) => ({
  name,
  first_name,
  last_name,
  email,
  group: groups.find((group) => ['Manager', 'Operator', 'ProdTech'].includes(group)) || '',
  isDispatcher: groups.includes('Dispatcher'),
  isCustomerService: groups.includes('CustomerService'),
  groupsString: groups.join(', '),
  routes,
  id,
  is_active,
  has_logged,
  available: !!available,
});

export const getStaff = (state) => state.staff;
export const getStaffData = (state) => state.staff.data;
export const getStaffNextURL = (state) => state.staff.next;
const getSingleStaffData = (state) => state.staff.single.data;

export const getStaffById = (state, id) =>
  state.staff.data.find((u) => u.id.toString() === id.toString());

export const getAllStaff = createSelector([getStaffData], (staff) => arrayize(staff).map(mapStaff));

export const getSingleStaff = createSelector(
  [getSingleStaffData],
  (staff) => staff && mapStaff(staff)
);

export const getAllUsersSorted = createSelector([getAllStaff], (staff) =>
  staff.sort(usersIncreasingAlphabetical)
);
